import { GAME_UPDATE, MODAL_SHOW, MODAL_HIDE, GAME_SET_QUESTION, GAME_USER_SELECT_ANSWER, GAME_USER_UPDATE, GAME_SET_SCREEN, GAME_SET_TIME_TO_OPENING_CREDITS, GAME_ON_QUESTION_COMPLETE } from '../constants/action-types';
const initialState = {
    open: false,
    modal: null,
    closable: true
};


const modalReducer = (state = initialState, action) => {

    switch (action.type) {
        case MODAL_HIDE:
            return Object.assign({}, {
                open: false,
                modal: state.modal,
                closable: true
            });
        case MODAL_SHOW:
            return Object.assign({}, {
                open: true,
                modal: action.modal,
                closable: typeof action.closable !== 'undefined' ? action.closable : state.currentModalClosable
            })
        default: return state
    }
};

export default modalReducer


// WEBPACK FOOTER //
// ./src/reducers/modal-reducer.js